module.exports = __webpack_public_path__ + "img/profile.97431a86.jpg";